module.exports = __webpack_public_path__ + "static/media/4ODA11.9b300beb.jpg";